import { render, staticRenderFns } from "./CaseListItem.vue?vue&type=template&id=576250ab&scoped=true&lang=pug&"
import script from "./CaseListItem.vue?vue&type=script&lang=js&"
export * from "./CaseListItem.vue?vue&type=script&lang=js&"
import style0 from "./CaseListItem.vue?vue&type=style&index=0&id=576250ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576250ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
